import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class EventService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetEvent():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Event/Get`);
  }

  DeleteEvent(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Event/Delete?id=${id}`);
  }

  CreateEvent(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Event/Create`,data);
  }
  UpdateEvent(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Event/Update`,data)
  }
}
